import "draft-js-alignment-plugin/lib/plugin.css";
import "draft-js-linkify-plugin/lib/plugin.css";
import "./RichEditor.css";
import React from "react";
// import Editor from "draft-js-plugins-editor";
import {
  EditorState,
  RichUtils,
  AtomicBlockUtils
} from "draft-js";
import createLinkifyPlugin from "draft-js-linkify-plugin";

import InlineStyleControls from "./InlineStyleControls";
import BlockStyleControls from "./BlockStyleControls";

import Editor, { composeDecorators } from "draft-js-plugins-editor";

import createImagePlugin from "draft-js-image-plugin";

import createAlignmentPlugin from "draft-js-alignment-plugin";

import createFocusPlugin from "draft-js-focus-plugin";

import createResizeablePlugin from "draft-js-resizeable-plugin";

import createVideoPlugin from "draft-js-video-plugin";

import createCounterPlugin from "draft-js-counter-plugin";

const counterPlugin = createCounterPlugin();

const { CustomCounter } = counterPlugin;

const videoPlugin = createVideoPlugin();

const linkifyPlugin = createLinkifyPlugin();

const { types } = videoPlugin;

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
// const blockDndPlugin = createBlockDndPlugin();
const alignmentPlugin = createAlignmentPlugin();
const { AlignmentTool } = alignmentPlugin;

const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator
  //   blockDndPlugin.decorator
);
const imagePlugin = createImagePlugin({ decorator });

const plugins = [
  //   blockDndPlugin,
  focusPlugin,
  alignmentPlugin,
  resizeablePlugin,
  imagePlugin,
  videoPlugin,
  counterPlugin,
  linkifyPlugin
];

export default class RichEditor extends React.Component {
  state = {
    videoUrl: ""
  };
  getBlockStyle = block => {
    switch (block.getType()) {
      case "blockquote":
        return "RichEditor-blockquote";

      default:
        return null;
    }
  };
  handleChange = editorState => {
    this.props.handleEditor(editorState);
  };

  handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.handleChange(newState);
      return true;
    }
    return false;
  };
  toggleInlineStyle = InlineStyle => {
    this.handleChange(
      RichUtils.toggleInlineStyle(this.props.editorState, InlineStyle)
    );
  };
  toggleBlockType = blockType => {
    this.handleChange(
      RichUtils.toggleBlockType(this.props.editorState, blockType)
    );
  };
  handleImageChange = editorState => {
    // console.log(editorState.target.files);
    this.props.handleImageChange("IMAGE_DESC", editorState);
  };
  handleVideoChange = () => {
    const { editorState } = this.props;

    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      types.VIDEOTYPE,
      "IMMUTABLE",
      { src: this.state.videoUrl }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    let newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity
    });
    newEditorState = AtomicBlockUtils.insertAtomicBlock(
      newEditorState,
      entityKey,
      " "
    );
    this.handleChange(newEditorState);
  };

  customCountFunction = str => {
    const wordArray = str.match(/\S+/g); // matches words according to whitespace
    const word_count = wordArray ? wordArray.length : 0;
    this.props.wordCount(word_count);
    return word_count;
  };
  focus = () => {
    this.editor.focus();
  };
  render() {
    const { editorState } = this.props;

    let className = "RichEditor-editor";

    let contentState = this.props.editorState.getCurrentContent();

    if (!contentState.hasText()) {
      if (
        contentState
          .getBlockMap()
          .first()
          .getType() !== "unstyled"
      ) {
        className += " RichEditor-hidePlaceholder";
      }
    }
    // Custom overrides for "code" style.
    const styleMap = {
      CODE: {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        fontSize: 16,
        padding: 2
      }
    };
    return (
      <div className="RichEditor-root">
        <BlockStyleControls
          editorState={editorState}
          onToggle={this.toggleBlockType}
        />

        <InlineStyleControls
          editorState={editorState}
          onToggle={this.toggleInlineStyle}
        />
        <div style={{ display: "flex" }}>
          <div style={{ width: "20%" }}>
            <input
              type="file"
              id="addimage"
              className="custom-file-input"
              onChange={this.handleImageChange}
            />
          </div>
          <div style={{ flex: 2 }}>
            <button
              type="submit"
              style={{
                padding: "5px 8px",
                border: "1px solid #999",
                borderRadius: "3px",
                backgroundColor: "#f1f1f1"
              }}
              onClick={this.handleVideoChange}
            >
              Add Video
            </button>
            <input
              type="text"
              id="addVideo"
              onChange={e => this.setState({ videoUrl: e.target.value })}
              value={this.state.videoUrl}
              style={{
                width: "40%",
                marginLeft: "10px",
                padding: "6px 12px",
                color: "inherit"
              }}
            />
          </div>
        </div>
        <div id="rich-editor" className={className} onClick={this.focus}>
          <Editor
            blockStyleFn={this.getBlockStyle}
            editorState={editorState}
            onChange={this.handleChange}
            ref={element => {
              this.editor = element;
            }}
            plugins={plugins}
            customStyleMap={styleMap}
            spellCheck={true}
            placeholder={this.props.placeholder}
            handleKeyCommand={this.handleKeyCommand}
          />
          <AlignmentTool />
          <div>
            <CustomCounter countFunction={this.customCountFunction} /> words
          </div>
        </div>
      </div>
    );
  }
}
